// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    loadStationDetails,
    updateStationDetails,
} from '../../redux/reducers/stations';

import Loader from '../../components/Loader/Loader';
import MessageBlock from '../../components/MessageBlock/MessageBlock';

import FormWrapper from '../../components/shared/FormWrapper';

import StationEditForm from '../../components/Stations/Edit';

class StationsEdit extends Component {
    onSubmit: Function;

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(
            loadStationDetails(this.props.match.params.stationId)
        );
    }

    onSubmit(formValues) {
        const { dispatch, station, history } = this.props;

        const stationData = {
            stationName: formValues.name,
            stationCode: formValues.code,
            stationLat: formValues.lat,
            stationLong: formValues.long,
        };

        dispatch(
            updateStationDetails(station.stationId, stationData)
        ).then(updatedStation => {
            history.push('/stations');
        });
    }

    render() {
        const { station, isFetching, errorFetching } = this.props;

        if (errorFetching) {
            return (
                <FormWrapper>
                    <MessageBlock message="An unexpected error occurred whilst loading this station." />
                </FormWrapper>
            );
        }

        if (isFetching) {
            return (
                <FormWrapper>
                    <Loader message="Loading station, please wait..." />
                </FormWrapper>
            );
        }

        if (!isFetching && station) {
            const initialValues = {
                name: station.stationName,
                code: station.stationCode,
                lat: station.stationLat,
                long: station.stationLong,
            };

            return (
                <FormWrapper>
                    <StationEditForm
                        station={station}
                        initialValues={initialValues}
                        onSubmit={this.onSubmit}
                    />
                </FormWrapper>
            );
        }

        return null;
    }
}

const mapStateToProps = state => {
    const edit = state.stations.edit;

    return {
        errorFetching: edit.error,
        isFetching: edit.fetching,
        station: edit.station,
    };
};

export default withRouter(connect(mapStateToProps)(StationsEdit));



// WEBPACK FOOTER //
// ./src/containers/StationsEdit/StationsEdit.js